import { useEditorStore } from '../../store/editor.store'

interface SectionPreset {
  id: string
  name: string
  icon: string
  desc: string
  blocks: Array<{ type: string; data: Record<string, unknown> }>
}

const PRESETS: SectionPreset[] = [
  {
    id: 'blank', name: 'Пустая секция', icon: '⬜', desc: 'Добавить пустую секцию',
    blocks: [],
  },
  {
    id: 'hero', name: 'Главный экран', icon: '🏠', desc: 'Заголовок + подзаголовок + кнопка',
    blocks: [
      { type: 'hero-centered', data: { title: 'Заголовок вашего сайта', subtitle: 'Подзаголовок с ключевым преимуществом', primaryButton: { text: 'Начать бесплатно', url: '#contact' }, backgroundImage: '' } },
    ],
  },
  {
    id: 'features-3', name: 'Преимущества', icon: '✦', desc: 'Три ключевых преимущества с иконками',
    blocks: [
      { type: 'features', data: { title: 'Почему выбирают нас', subtitle: 'Наши ключевые преимущества', columns: 3, items: [
        { icon: '⚡', title: 'Быстро', description: 'Результат уже на следующий день' },
        { icon: '💎', title: 'Качественно', description: 'Профессиональный подход к каждому проекту' },
        { icon: '🎯', title: 'Эффективно', description: 'Решения, которые работают на вашу цель' },
      ] } },
    ],
  },
  {
    id: 'image-text', name: 'Текст + Изображение', icon: '🖼', desc: 'Фото слева и текст справа',
    blocks: [
      { type: 'image-text', data: { title: 'О нас', text: 'Расскажите о своей компании, опыте и ценностях. Что делает вас уникальными и почему клиенты выбирают именно вас.', image: '', imagePosition: 'left', buttonText: 'Узнать больше', buttonUrl: '#' } },
    ],
  },
  {
    id: 'testimonials', name: 'Отзывы клиентов', icon: '⭐', desc: 'Три отзыва в карточках',
    blocks: [
      { type: 'testimonials', data: { title: 'Что говорят клиенты', items: [
        { name: 'Анна Петрова', role: 'CEO компании', text: 'Отличный сервис! Очень довольны результатом и профессионализмом команды.' },
        { name: 'Максим Иванов', role: 'Маркетолог', text: 'Рекомендую всем. Подход индивидуальный, результаты превзошли ожидания.' },
        { name: 'Елена Сидорова', role: 'Предприниматель', text: 'Работали с ними уже три раза. Каждый раз высокое качество и соблюдение сроков.' },
      ] } },
    ],
  },
  {
    id: 'pricing', name: 'Тарифные планы', icon: '💰', desc: 'Три плана с ценами и функциями',
    blocks: [
      { type: 'pricing', data: { title: 'Выберите план', subtitle: 'Начните бесплатно, масштабируйтесь по мере роста', plans: [
        { name: 'Стартовый', price: 'Бесплатно', period: 'навсегда', features: ['1 проект', 'Базовые функции', 'Email поддержка'], ctaText: 'Начать бесплатно', highlighted: false },
        { name: 'Профи', price: '1 990 ₽', period: '/мес', features: ['10 проектов', 'Все функции', 'Приоритетная поддержка', 'Аналитика'], ctaText: 'Выбрать план', highlighted: true },
        { name: 'Бизнес', price: '4 990 ₽', period: '/мес', features: ['Неограниченно', 'API доступ', 'Персональный менеджер', 'SLA гарантия'], ctaText: 'Связаться', highlighted: false },
      ] } },
    ],
  },
  {
    id: 'faq', name: 'Частые вопросы', icon: '❓', desc: 'Аккордеон с вопросами и ответами',
    blocks: [
      { type: 'faq', data: { title: 'Часто задаваемые вопросы', items: [
        { question: 'Как начать работу?', answer: 'Просто зарегистрируйтесь и следуйте инструкциям. Процесс занимает не более 5 минут.' },
        { question: 'Есть ли бесплатный период?', answer: 'Да, мы предлагаем 14-дневный бесплатный пробный период без привязки карты.' },
        { question: 'Как отменить подписку?', answer: 'Вы можете отменить подписку в любой момент в настройках аккаунта. Деньги за неиспользованный период возвращаются.' },
        { question: 'Какие способы оплаты принимаете?', answer: 'Мы принимаем все популярные банковские карты, СБП, и Яндекс Пэй.' },
      ] } },
    ],
  },
  {
    id: 'cta', name: 'Призыв к действию', icon: '🚀', desc: 'Яркий CTA с кнопкой',
    blocks: [
      { type: 'cta', data: { title: 'Готовы начать?', subtitle: 'Присоединяйтесь к тысячам клиентов, которые уже используют наш продукт', buttonText: 'Начать бесплатно', buttonUrl: '#contact', variant: 'accent' } },
    ],
  },
  {
    id: 'contact-form', name: 'Форма контактов', icon: '✉', desc: 'Контактная форма с полями',
    blocks: [
      { type: 'form', data: { title: 'Свяжитесь с нами', subtitle: 'Оставьте заявку и мы ответим в течение часа', fields: [
        { id: 'name', type: 'text', label: 'Имя', placeholder: 'Ваше имя', required: true },
        { id: 'email', type: 'email', label: 'Email', placeholder: 'your@email.com', required: true },
        { id: 'phone', type: 'tel', label: 'Телефон', placeholder: '+7 (___) ___-__-__', required: false },
        { id: 'message', type: 'textarea', label: 'Сообщение', placeholder: 'Ваш вопрос или пожелание', required: false },
      ], submitText: 'Отправить заявку', successMessage: 'Спасибо! Мы свяжемся с вами в ближайшее время.' } },
    ],
  },
  {
    id: 'stats', name: 'Статистика', icon: '📊', desc: 'Ключевые цифры и метрики',
    blocks: [
      { type: 'number-counter', data: { items: [
        { value: 1500, suffix: '+', label: 'Довольных клиентов' },
        { value: 98, suffix: '%', label: 'Положительных отзывов' },
        { value: 8, suffix: ' лет', label: 'На рынке' },
        { value: 50, suffix: '+', label: 'Специалистов в команде' },
      ], accentColor: '#5b6af0' } },
    ],
  },
  {
    id: 'team', name: 'Команда', icon: '👥', desc: 'Карточки участников команды',
    blocks: [
      { type: 'team', data: { title: 'Наша команда', subtitle: 'Профессионалы своего дела', members: [
        { name: 'Иван Петров', role: 'CEO & Основатель', bio: 'Более 10 лет опыта в индустрии', photo: '' },
        { name: 'Мария Сидорова', role: 'Директор по продукту', bio: 'Эксперт в UX/UI дизайне', photo: '' },
        { name: 'Алексей Козлов', role: 'Технический директор', bio: 'Разработчик с 15-летним стажем', photo: '' },
      ] } },
    ],
  },
  {
    id: 'process', name: 'Как мы работаем', icon: '📋', desc: 'Пошаговый процесс работы',
    blocks: [
      { type: 'process-steps', data: { title: 'Как мы работаем', items: [
        { number: '01', title: 'Заявка', description: 'Оставьте заявку или свяжитесь с нами удобным способом' },
        { number: '02', title: 'Консультация', description: 'Бесплатно обсудим задачи и предложим решения' },
        { number: '03', title: 'Работа', description: 'Наши специалисты приступают к выполнению задачи' },
        { number: '04', title: 'Результат', description: 'Принимаете работу и оплачиваете только после одобрения' },
      ] } },
    ],
  },
  {
    id: 'gallery', name: 'Галерея', icon: '🖼', desc: 'Сетка изображений',
    blocks: [
      { type: 'gallery', data: { title: 'Наши работы', columns: 3, images: [
        { url: '', alt: 'Работа 1' }, { url: '', alt: 'Работа 2' }, { url: '', alt: 'Работа 3' },
        { url: '', alt: 'Работа 4' }, { url: '', alt: 'Работа 5' }, { url: '', alt: 'Работа 6' },
      ] } },
    ],
  },
  {
    id: 'newsletter', name: 'Подписка', icon: '📧', desc: 'Форма подписки на рассылку',
    blocks: [
      { type: 'newsletter', data: { title: 'Будьте в курсе', subtitle: 'Подпишитесь на наши обновления и получайте полезные материалы', placeholder: 'Ваш email', buttonText: 'Подписаться', formId: 'newsletter' } },
    ],
  },
  {
    id: 'logos', name: 'Партнёры / Клиенты', icon: '🤝', desc: 'Логотипы компаний-клиентов',
    blocks: [
      { type: 'logo-strip', data: { title: 'Нам доверяют', items: [
        { name: 'Компания 1', logo: '', url: '#' }, { name: 'Компания 2', logo: '', url: '#' }, { name: 'Компания 3', logo: '', url: '#' },
        { name: 'Компания 4', logo: '', url: '#' }, { name: 'Компания 5', logo: '', url: '#' },
      ], grayscale: true } },
    ],
  },
  {
    id: 'video', name: 'Видео', icon: '▶', desc: 'Встроенное видео YouTube/Vimeo',
    blocks: [
      { type: 'video', data: { title: 'Смотрите, как это работает', videoUrl: '', autoplay: false } },
    ],
  },
]

interface Props {
  onClose: () => void
}

export function SectionPresetsModal({ onClose }: Props) {
  const store = useEditorStore.getState()

  function applyPreset(preset: SectionPreset) {
    store.addSection()
    const added = useEditorStore.getState().page.sections.at(-1)
    if (added && preset.blocks.length > 0) {
      for (const block of preset.blocks) {
        store.addBlock(added.id, block.type, block.data)
      }
    }
    onClose()
  }

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 9000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}
      onClick={e => { if (e.target === e.currentTarget) onClose() }}
    >
      <div style={{ background: 'var(--bg-1)', border: '1px solid var(--border)', borderRadius: '20px', width: '820px', maxWidth: '100%', maxHeight: '85vh', overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 32px 80px rgba(0,0,0,0.4)' }}>
        {/* Header */}
        <div style={{ padding: '20px 24px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
          <div>
            <div style={{ fontSize: '16px', fontWeight: 800, color: 'var(--text-primary)' }}>Добавить секцию</div>
            <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '2px' }}>Выберите готовый шаблон или начните с пустой секции</div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '22px', color: 'var(--text-muted)', cursor: 'pointer' }}>×</button>
        </div>

        {/* Grid */}
        <div style={{ overflowY: 'auto', padding: '20px 24px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px' }}>
            {PRESETS.map(preset => (
              <button
                key={preset.id}
                onClick={() => applyPreset(preset)}
                style={{
                  padding: '16px 12px', background: 'var(--bg-2)', border: '1px solid var(--border)',
                  borderRadius: '12px', cursor: 'pointer', textAlign: 'left', transition: 'all 0.15s',
                  display: 'flex', flexDirection: 'column', gap: '6px',
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--accent)'; e.currentTarget.style.background = 'var(--bg-3)' }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.background = 'var(--bg-2)' }}
              >
                <div style={{ fontSize: '22px', lineHeight: 1 }}>{preset.icon}</div>
                <div style={{ fontSize: '13px', fontWeight: 700, color: 'var(--text-primary)', lineHeight: 1.3 }}>{preset.name}</div>
                <div style={{ fontSize: '11px', color: 'var(--text-muted)', lineHeight: 1.4 }}>{preset.desc}</div>
                {preset.blocks.length > 0 && (
                  <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginTop: '2px', display: 'flex', flexWrap: 'wrap', gap: '3px' }}>
                    {preset.blocks.map((b, i) => (
                      <span key={i} style={{ background: 'var(--bg-1)', border: '1px solid var(--border)', borderRadius: '4px', padding: '1px 5px' }}>
                        {b.type}
                      </span>
                    ))}
                  </div>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
